import request from '@/utils/request'

/**
 * 获取 Session 列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function getSessions(params) {
  return request({
    url: '/sessions',
    method: 'get',
    params
  })
}

/**
 * 获取单个 Session 详情
 * @param {Number} sessionId Session ID
 * @returns {Promise}
 */
export function getSession(sessionId) {
  return request({
    url: `/sessions/${sessionId}`,
    method: 'get'
  })
}

/**
 * 创建 Session
 * @param {Object} data Session 数据
 * @returns {Promise}
 */
export function createSession(data) {
  return request({
    url: '/sessions',
    method: 'post',
    data
  })
}

/**
 * 更新 Session
 * @param {Number} sessionId Session ID
 * @param {Object} data 更新数据
 * @returns {Promise}
 */
export function updateSession(sessionId, data) {
  return request({
    url: `/sessions/${sessionId}`,
    method: 'put',
    data
  })
}

/**
 * 删除 Session
 * @param {Number} sessionId Session ID
 * @returns {Promise}
 */
export function deleteSession(sessionId) {
  return request({
    url: `/sessions/${sessionId}`,
    method: 'delete'
  })
}
